module.exports = {"532530101":"金河镇","532530102":"金水河镇","532530103":"勐拉镇","532530104":"老勐镇","532530202":"铜厂乡","532530204":"老集寨乡","532530205":"者米拉祜族乡","532530206":"阿得博乡","532530207":"沙依坡乡","532530208":"大寨乡","532530209":"马鞍底乡","532530210":"勐桥乡","532530211":"营盘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532530.json
// module id = 2634
// module chunks = 0